import { Injectable, Pipe, PipeTransform } from '@angular/core';

import { FinnairItineraryItem } from '@fcom/dapi/api/models/finnair-itinerary-item';
import { FinnairItineraryItemFlight } from '@fcom/dapi/api/models/finnair-itinerary-item-flight';
import { ItineraryItemFlight } from '@fcom/dapi/api/models/itinerary-item-flight';
import { ItineraryItemLayover } from '@fcom/dapi/api/models/itinerary-item-layover';

/**
 * Map all flight numbers of one bound.
 */
@Injectable()
@Pipe({
  name: 'finFlightNumbers',
  pure: true,
  standalone: false,
})
export class FlightNumbersPipe implements PipeTransform {
  transform(itinerary: Array<FinnairItineraryItem | ItineraryItemFlight | ItineraryItemLayover>): string {
    return (
      itinerary
        ?.map((i: FinnairItineraryItemFlight) => i?.flightNumber)
        .filter(Boolean)
        .join(', ') ?? ''
    );
  }
}
